import { render, staticRenderFns } from "./payPage.vue?vue&type=template&id=1482a6b0&"
import script from "./payPage.vue?vue&type=script&lang=js&"
export * from "./payPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports